export default "__VITE_ASSET__Ce21NwPv__"